'use strict';

const _ = require('underscore');

module.exports = class IdeaQuery {
    constructor(states) {
        this._states = _.sortBy(states, s => s);
    }

    get states() {
        return this._states;
    }

    toString() {
        return this._states.join(':')
    }

    isSelected(state) {
        if(!this._states || this._states.length == 0) {
            return true;
        }

        return _.contains(this._states, state);
    }
}


// WEBPACK FOOTER //
// ./feedback/domain/value/idea-query.js